import { PRODUCT_TYPE_OPTIONS } from "variables/constants";
import { publisherDealData } from "components/Common/constants";
import { PUBLISHER_OPTIONS, ROLE_OPTIONS } from "./constants";
import { options } from "dropzone";
import { DEMAND_PARTNER_GAM } from "components/Common/constants";

export const dealTabFormFields = (
  PUBLISHER_OPTIONS = [],
  PRODUCT_TYPE_OPTIONS = [],
  formState,
  isEditMode = false,
) => [
    {
      id: "publisher_name",
      name: "publisher_name",
      label: "Publisher Name",
      required: true,
      type: "dropdown",
      isSearchable: true,
      placeholder: "Select Publisher",
      options: PUBLISHER_OPTIONS,
      disabled: isEditMode,
      isMulti: false,
      hasMore: true,
    },
    {
      id: "dealname",
      name: "name",
      label: "Deal Name",
      required: true,
      type: "text",
      placeholder: "Enter deal name",
    },
     {
      id: "demandPartner",
      name: "demandPartner",
      isSearchable: false,
      label: "Demand Partner",
      required: true,
      type: "dropdown",
      options: [
        { label: "Gam", value: "GAM" },
        { label: "Meta", value: "META" },
      ],
      placeholder: "Select Demand Partner",
    },
    {
      id: "gam_ad_unit_code",
      name: "adUnitCodes",
      label: formState?.values?.demandPartner === DEMAND_PARTNER_GAM ? "Ad Unit Codes" : "Campaign Code",
      required: true,
      type: "taginput",
      placeholder: formState?.values?.demandPartner === DEMAND_PARTNER_GAM ? "Enter Ad Unit Code and press Enter" : "Enter Campaign Code",
      colSize: 12,
      plain: true,
    },
    {
      id: "product_type",
      name: "product_type",
      label: "Product Type",
      required: true,
      isSearchable: false,
      type: "dropdown",
      placeholder: "Select Product Type",
      options: PRODUCT_TYPE_OPTIONS,
      isMulti: false,
    },
    {
      id: "dealType",
      name: "dealType",
      label: "Deal Type",
      required: true,
      isSearchable: false,
      type: "dropdown",
      placeholder: "Select Deal Type...",
      options: [
        { label: "eCPM", value: "ECPM" },
        { label: "Revenue Share", value: "REVENUE_SHARE" },
      ],
      isMulti: false,
    },

  {
    id: "revenue_share",
    name: "revenueShare",
    label: "Publisher Revenue Share (%)",
    required: true,
    // breakAfter: true,
    type: "number",
    placeholder: "0-100",
    min: 0,
    max: 100,
    showWhen: {
      field: "dealType",
      equals: ["REVENUE_SHARE"],
    },
  },

  {
    id: "eCPM",
    name: "ecpm",
    label: "Publisher eCPM",
    required: true,
    // breakAfter: true,
    type: "number",
    placeholder: "Enter eCPM",
    showWhen: {
      field: "dealType",
      equals: ["ECPM"],
    },
  },
  {
    id: "start_date",
    name: "start_date",
    label: "Start Date",
    required: true,
    breakAfter: true,
    isSearchable: false,
    type: "date",
    placeholder: "Select Start Date",
  },
  {
    id: "status",
    name: "status",
    label: "Deal Status",
    type: "toggle",
    breakAfter: true,
    showToogleatEnd: false,
  },
  // {
  //   id: "margin_section",
  //   type: "section",
  //   title: "Margin Management",
  //   colSize: 12,
  // },
  // {
  //   id: "margin",
  //   name: "margin",
  //   label: "Add Margin (%)",
  //   required: true,
  //   type: "number",
  //   placeholder: "0-100",
  //   min: 0,
  //   max: 100,
  // },
  // {
  //   id: "start_date",
  //   name: "start_date",
  //   label: "Start Date",
  //   required: true,
  //   type: "date",
  //   placeholder: "Select Start Date",
  // },
  //    {
  //   id: "adjustment_types",
  //   name: "adjustment_types",
  //   label: "Adjustment Types",
  //   required: false,
  //   type: "dropdown",
  //   placeholder: "Select Adjustment...",
  //   options: [
  //     { value: "ad_requestes", label: "Ad Requests" },
  //     { value: "impression", label: "Impression" },
  //     { value: "revnue", label: "Revenue" },
  //     { value: "pnl", label: "PNL" },
  //   ],
  //   isSearchable: true,

  // },

  {
    id: "create_tag",
    name: "create_tag",
    label: "Create a tag?",
    colSize: 12,
    required: false,
    isSearchable: false,
    type: "checkbox",
    breakAfter: true,
  },
  {
    id: "tag_section",
    type: "section",
    title: "Tag Configuration",
    colSize: 12,
    showWhen: {
      field: "create_tag",
      equals: [true],
    },
  },
  {
    id: "tag_name",
    name: "tag_name",
    label: "Tag Name",
    type: "text",
    required: true,
    placeholder: "Enter tag name",
    colSize: 6,
    showWhen: {
      field: "create_tag",
      equals: [true],
    },
  },
  // {
  //   id: "floor_price",
  //   name: "floor_price",
  //   label: "Floor Price (CPM)",
  //   type: "number",
  //   placeholder: "Enter floor price",
  //   min: 0,
  //   step: 0.01,
  //   showWhen: {
  //     field: "create_tag",
  //     equals: [true],
  //   },
  //   breakAfter: true,
  // },
  {
    id: "tag_content",
    name: "tag_content",
    label: "Tag Content",
    type: "textarea",
    required: true,
    placeholder: "Enter Tag Content",
    rows: 6,
    colSize: 12,
    showWhen: {
      field: "create_tag",
      equals: [true],
    },
  },

  {
    id: "tstatus",
    name: "tstatus",
    label: "Tag Status",
    type: "toggle",
    showToogleatEnd: false,
    breakAfter: true,
    showWhen: {
      field: "create_tag",
      equals: [true],
    },
  },
];

export const marginTabFormFields = (
  PRODUCT_TYPE_OPTIONS = [],
  PUBLISHER_OPTIONS = [],
  DEAL_OPTIONS = [],
  isEditMode,
) => [
  {
    id: "publisher_list",
    name: "publisher_name",
    label: "Publisher",
    type: "dropdown",
    isMulti: false,
    placeholder: "Select Publishers...",
    options: PUBLISHER_OPTIONS,
    disabled: isEditMode,
    isSearchable: true,
    required: true,
    // showWhen: {
    //   field: "scope_type",
    //   equals: ["publisher_level", "deal_level", "product_type"],
    // },
  },
  {
    id: "deal_list",
    name: "deal_name",
    label: "Deal",
    required: false,
    type: "dropdown",
    placeholder: "Select Deals...",
    options: DEAL_OPTIONS,
    disabled: isEditMode,
    isMulti: false,
    isSearchable: true,
    required: true,
    // showWhen: { field: "scope_type", equals: ["deal_level"] },
  },
  {
    id: "adjustment_types",
    name: "adjustment_types",
    label: "Adjustment Types",
    required: true,
    type: "dropdown",
    placeholder: "Select Adjustment...",
    options: [
      { value: "REQUEST", label: "Ad Requests" },
      { value: "IMPRESSIONS", label: "Impression" },
      // { value: "revnue", label: "Revenue" },
      { value: "PNL", label: "PNL" },
    ],
    isMulti: true,
    isSearchable: true,
  },
  {
    type: "dropdown-input",
    label: "Margin Percentage",
    id: "margin_percent",
    inputName: "margin_percent",
    inputPlaceholder: "Margin Percentage",
    inputType: "number",
    inputWidth: "50%",
    name: "margin_percent",
    name: "margin_action",
    colSize: 6,
    required: true,
    dropdownName: "margin_action",
    dropdownOptions: [
      { value: "REDUCE", label: "Reduce" },
      { value: "INCREASE", label: "Increase" },
    ],
    dropdownPlaceholder: "Margin Actions",
    dropdownWidth: "50%",
    max: 100,
  },

  {
    id: "start_date",
    name: "start_date",
    label: "Start Date",
    required: true,
    type: "date",
    placeholder: "Select Start Date",
    disabled: isEditMode,
  },

  // {
  //   id: "scope_type",
  //   name: "scope_type",
  //   label: "Scope Type",
  //   required: true,
  //   isSearchable: false,
  //   type: "dropdown",
  //   placeholder: "Select Scope Type...",
  //   options: [
  //     { value: "product_type", label: "Product Type" },
  //     { value: "publisher_level", label: "Publisher Level" },
  //     { value: "deal_level", label: "Deal Level" },
  //   ],
  //   isMulti: false,
  // },

  // {
  //   name: "productType",
  //   label: "Product Type",
  //   type: "dropdown",
  //   options: PRODUCT_TYPE_OPTIONS,
  //   placeholder: "Select product type",
  //   required: true,
  //   isMulti: false,

  //   // showWhen: {
  //   //   field: "scope_type",
  //   //   equals: ["product_type"],
  //   // },
  // },

  // {
  //   id: "status",
  //   name: "status",
  //   label: "Margin Management Status",
  //   type: "toggle",
  //   breakAfter: true,
  //   showToogleatEnd: true,
  // },
];

export const insertionOrderFormFields = (
  PUBLISHER_OPTIONS = [],
  isEditMode = false,
) => [
  {
    name: "ioName",
    label: "IO Name",
    type: "text",
    required: true,
    placeholder: "Enter IO Name",
  },
  {
    name: "publisher",
    label: "Publisher",
    type: "dropdown",
    required: true,
    placeholder: "Select Publisher",
    options: PUBLISHER_OPTIONS,
    isMulti: false,
    hasMore: true,
    disabled: isEditMode,
  },
  {
    name: "startDate",
    label: "Start Date",
    placeholder: "Start Date",
    type: "date",
    required: true,
  },
  {
    name: "endDate",
    label: "End Date",
    placeholder: "End Date",
    type: "date",
    dependsOn: "startDate",
    required: false,
  },
  {
    name: "status",
    label: "IO Status",
    type: "toggle",
    showToogleatEnd: true,
  },
];

export const publisherFormFields = (
  PRODUCT_TYPE_OPTIONS = [],
  isEditMode = false,
) => [
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
    required: true,
    placeholder: "Enter company name",
    colSize: 12,
  },
  {
    name: "address",
    label: "Company Address",
    type: "textarea",
    placeholder: "Enter company address",
    colSize: 12,
    required: true,
  },
  {
    name: "email",
    label: "Primary Email (For Login)",
    type: "email",
    required: true,
    placeholder: "Enter primary email",
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
    disabled: isEditMode,
  },
  {
    name: "pocPhone",
    label: "Phone",
    type: "text",
    required: true,
    placeholder: "Enter phone number",
    // validate: {
    //   pattern: /^[0-9]{10}$/,
    //   message: "Phone number must be 10 digits",
    // },
    disabled: isEditMode,
  },
  {
    name: "pocFirstName",
    label: "POC First Name",
    type: "text",
    placeholder: "Enter first name",
  },
  {
    name: "pocLastName",
    label: "POC Last Name",
    type: "text",
    placeholder: "Enter last name",
  },
  {
    name: "accountingEmail",
    label: "Accounting Email",
    type: "email",
    placeholder: "Enter accounting email",
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
  },
  {
    name: "reportingEmail",
    label: "Reporting Email",
    type: "text",
    required: true,
    placeholder: "Reporting emails e.g abc@truelift.com, xyz@truelift.com",
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
  },
  {
    name: "gamNetworkID",
    label: "GAM Network ID",
    required: true,
    type: "text",
    placeholder: "Enter GAM Network ID",
  },
  {
    name: "gamAdminEmail",
    label: "GAM Admin Email",
    type: "email",
    placeholder: "Enter GAM admin email",
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
  },
  {
    name: "productType",
    label: "Product Type",
    type: "MultiSelectDropdown",
    options: PRODUCT_TYPE_OPTIONS,
    placeholder: "Select product type",
    required: false,
    isMulti: true,
    required: true,
  },
  {
    name: "status",
    label: "Status",
    type: "toggle",
    showToogleatEnd: true,
  },
];

export const publisherOptions = publisherDealData.map(({ value, label }) => ({
  value,
  label,
}));

export const userFormFields = (PRODUCT_TYPE_OPTIONS = []) => [
  {
    id: "name",
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    placeholder: "Enter user name",
    // maxLength: 100,
    // showCharCount: true,
    colSize: 6,
  },

  {
    id: "email",
    name: "email",
    label: "Email",
    type: "text",
    required: true,
    placeholder: "Enter user email",
    // maxLength: 100,
    // showCharCount: true,
    colSize: 6,
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
  },
  {
    name: "role",
    label: "Role",
    type: "dropdown",
    options: ROLE_OPTIONS,
    isMulti: false,
    placeholder: "Select role",
    required: true,
  },
  {
    name: "productType",
    label: "Product Type",
    type: "MultiSelectDropdown",
    options: PRODUCT_TYPE_OPTIONS,
    placeholder: "Select product type",
    required: false,
    isMulti: true,
  },

  {
    id: "status",
    name: "status",
    label: "Status",
    type: "toggle",
    showToogleatEnd: true,
  },
];

export const tagFormFields = (
  PUBLISHER_OPTIONS = [],
  DEAL_OPTIONS = [],
  isEditMode = false,
) => [
    {
      id: "publisher",
      name: "publisher",
      label: "Publisher",
      type: "dropdown",
      required: true,
      isSearchable: true,
      isMulti: false,
      placeholder: "Select Publisher",
      options: PUBLISHER_OPTIONS,
      disabled: isEditMode,
      hasMore: true,
    },
    {
      id: "deal",
      name: "deal",
      label: "Deal",
      type: "dropdown",
      isMulti: false,
      required: true,
      isSearchable: true,
      placeholder: "Select Deal",
      options: DEAL_OPTIONS,
      hasMore: true,
      dependsOn: "publisher",
      disabled: isEditMode,
    },
    {
      id: "tagName",
      name: "tagName",
      label: "Tag Name",
      type: "text",
      required: true,
      placeholder: "Enter tag name",
      colSize: 12,
    },
    {
      id: "content",
      name: "content",
      label: "Tag Content",
      type: "textarea",
      required: true,
      placeholder: "Enter Tag Content",
      rows: 6,
      colSize: 12,
    },
    // {
    //   id: "floor_price",
    //   name: "floor_price",
    //   label: "Floor Price (CPM)",
    //   type: "number",
    //   placeholder: "Enter floor price",
    //   min: 0,
    //   step: 0.01,
    // },
    {
      id: "status",
      name: "status",
      label: "Status",
      type: "toggle",
      showToogleatEnd: true,
    },
  ];

export const productTypeFormFields = [
  {
    id: "product_type_name",
    name: "name",
    label: "Product Type Name",
    type: "text",
    required: true,
    placeholder: "Enter product type name",
    colSize: 12,
  },
  {
    id: "status",
    name: "status",
    label: "Status",
    type: "toggle",
    showToogleatEnd: true,
  },
];


export const publisherUserFormFields = (
  PUBLISHER_OPTIONS = [],
  isEditMode = false,
) => [
  {
    name: "publisherID",
    label: "Publisher",
    type: "dropdown",
    required: true,
    placeholder: "Select Publisher",
    options: PUBLISHER_OPTIONS,
    isMulti: false,
    hasMore: true,
    disabled: isEditMode,
    colSize: 12,
  },
  {
    id: "name",
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    placeholder: "Enter user name",
    // maxLength: 100,
    // showCharCount: true,
    colSize: 6,
  },

  {
    id: "email",
    name: "email",
    label: "Email",
    type: "text",
    required: true,
    placeholder: "Enter user email",
    disabled: isEditMode,
    // maxLength: 100,
    // showCharCount: true,
    colSize: 6,
    validate: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Enter a valid email address",
    },
  },
  {
    id: "status",
    name: "status",
    label: "Status",
    type: "toggle",
    showToogleatEnd: true,
  },
];

export const adjustmentField = () => [
    {
     

      label: "Publisher",
      type: "dropdown",
      isMulti: false,
      placeholder: "Select Publishers...",
      // options: PUBLISHER_OPTIONS,
      disabled: true,
      // isSearchable: true,
      // required: true,
      // showWhen: {
      //   field: "scope_type",
      //   equals: ["publisher_level", "deal_level", "product_type"],
      // },
    },
    // {
    //   id: "deal_list",
    //   name: "deal_name",
    //   label: "Deal",
    //   required: false,
    //   type: "dropdown",
    //   placeholder: "Select Deals...",
    //   options: DEAL_OPTIONS,
    //   disabled: isEditMode,
    //   isMulti: false,
    //   isSearchable: true,
    //   required: true,
    //   // showWhen: { field: "scope_type", equals: ["deal_level"] },
    // },
    {
      id: "month",
      name: "month",
      label: "Month",
      required: true,
      disabled: true,
      type: "dropdown",
      placeholder: "Select Month...",
      options: [
        { value: "MARCH", label: "March" },
        { value: "APRIL", label: "April" },
        { value: "MAY", label: "May" },
        { value: "JUN", label: "jun" },
        // { value: "revnue", label: "Revenue" },
      ],
      isMulti: true,
      isSearchable: true,
    },
    // {
    //   type: "dropdown-input",
    //   label: "Margin Percentage",
    //   id: "margin_percent",
    //   inputName: "margin_percent",
    //   inputPlaceholder: "Margin Percentage",
    //   inputType: "number",
    //   inputWidth: "50%",
    //   name: "margin_percent",
    //   name: "margin_action",
    //   colSize: 6,
    //   required: true,
    //   dropdownName: "margin_action",
    //   dropdownOptions: [
    //     { value: "REDUCE", label: "Reduce" },
    //     { value: "INCREASE", label: "Increase" },
    //   ],
    //   dropdownPlaceholder: "Margin Actions",
    //   dropdownWidth: "50%",
    //   max: 100,

    // },

    // {
    //   id: "start_date",
    //   name: "start_date",
    //   label: "Start Date",
    //   required: true,
    //   type: "date",
    //   placeholder: "Select Start Date",
    //   disabled: isEditMode,
    // },

     {
      id: "adjustmentType",
      name: "adjustmentType",
      label: "Adjustment Type",
      required: true,
      disabled: false,
      type: "dropdown",
      placeholder: "Select Adjustment Type...",
      options: [
        { value: "POSITIVE", label: "Positive" },
        { value: "NEGATIVE", label: "Negative" },
      ],
      isMulti: true,
      isSearchable: true,
    },

    {
      id: "value",
      name: "value",
      label: "Value",
      required: true,
      isSearchable: false,
      type: "number",
      placeholder: "Enter Value",
      isMulti: false,
    },
    

    {
      id: "reason",
      name: "reason",
      label: "Reason",
      required: true,
      isSearchable: false,
      type: "text",
      placeholder: "Enter Reason",
      isMulti: false,
    },
    // {
    //   name: "productType",
    //   label: "Product Type",
    //   type: "dropdown",
    //   options: PRODUCT_TYPE_OPTIONS,
    //   placeholder: "Select product type",
    //   required: true,
    //   isMulti: false,

    //   // showWhen: {
    //   //   field: "scope_type",
    //   //   equals: ["product_type"],
    //   // },
    // },

    // {
    //   id: "status",
    //   name: "status",
    //   label: "Margin Management Status",
    //   type: "toggle",
    //   breakAfter: true,
    //   showToogleatEnd: true,
    // },
  ];